import { AxiosResponse } from "axios";
import instance from "../instance";
import { CityInterface } from "@/core/reatom/state/city";

export const getCity = async (cityId: number): Promise<CityInterface[]> => {
  try {
    const res: AxiosResponse<{ items: CityInterface[] }> = await instance.get(
      `/v1/cities`,
      {
        params: {
          country_id: cityId,
        },
      }
    );
    return res.data.items;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
